// TODO we need to keep this synced with UnicornConstants

export class FoundationsConstants {
    static COOKIE_NAME = 'AuthToken'
    static WORKSPACE_LIMIT = 9
    static TOKEN_STR = 'hl-user-token'
    static TOKEN_EXP_STR = 'hl-user-token-expiration'
    static BASE_URL = window.baseURL
    static DEVELOPER_MODE = false
    static THEME = 'classic' // default theme
    // static FOUNDATIONSLOADER = FoundationsLoader;
    static BANNER_UNINITIALIZED_TEXT = 'WARNING-UNINITIALIZED SYSTEM'
    static SESSION_EXTEND_EVENTS = ['click', 'touchstart', 'mousemove', 'scroll']
    static GENERAL_EVENTS_STR = 'generalEvents'
    static LAST_USER_INTERACTION = 'last-user-interaction'
    static TOKEN_REFRESH_IN_PROGRESS = 'token-refresh-in-progress'
    static NEW_USER = 'new-user-token'
    static OPENID_STATE = 'openId-state'

    static VISUAL_UNIT_TYPES = {
        TABLE_VIEW: 1,
        SUMMARY_VIEW: 2,
        PIE_CHART: 3,
        BAR_CHART: 4,
        LINE_CHART: 5,
        STACKEDBAR_CHART: 6,
        COLUMNGROUP_CHART: 7,
        SCATTER_CHART: 8,
        HEATMAP_CHART: 9,
        STACKEDCOLUMN_CHART: 10, //StackedColumn
    }

    static PrivacyLock = ['OpenUnlocked', 'LockedNotPrivate', 'PrivateNotVisible']

    static PrivacyLockText = {
        [FoundationsConstants.PrivacyLock[0]]: 'Unlocked, Open and Available',
        [FoundationsConstants.PrivacyLock[1]]:
            'Shared Lock, can be changed only by Owner and Administrators',
        [FoundationsConstants.PrivacyLock[2]]:
            'Locked(Private), visible only to Owner and Administrators',
    }

    static PRIMARY_COLOR = '#2969b7'

    static HLDATATYPE = {
        HLAge: '6',
        HLCount: '1',
        HLDate: '10',
        HLDuration: '3',
        HLList: '4',
        HLMoney: '2',
        HLPercentage: '8',
        HLNumber: '14',
        HLDecimal: '15',
        HLAgeDays: '13',
        HLText: '12',
        HLTime: '11',
        HLSearchList: '5',
        HLBusinessParameter: '16',
        HLSingleValueReport: '17',
        HLBooleanTF: '18',
        HLYesNo: '19',
        HLMeasureSet: '20',
    }
    static CHARTTYPE = {
        3: 'Pie',
        4: 'Bar',
        5: 'Line',
        6: 'StackedBar',
        7: 'ColumnGroup',
        8: 'Scatter',
        9: 'HeatMap',
        10: 'StackedColumn',
    }
    static ArrayMultipleAxisColor = ['#4572A7', '#89A54E', '#AA4643', '#870FA5', '#C7891F']

    static TEMPLATE_BASE_PATH_LITERAL = 'templates.UnicornTemplates.app.Templates.theme.classic'
}
